import React, { useEffect, useRef } from 'react';
import IPTS_2025 from '../Assets/Images/IPTS_2025.png';
import IPTS_2025_Inv from '../Assets/Images/IPTS_2025_Inv.png';
 
const NewsTicker = () => {
  const tickerRef = useRef(null);
 
  const newsItems = [
    {
      id: 1,
      text: "Visit Our Stall P205 for the Airport Automation Show at Inter Passenger Terminal Expo 2025 | June 11-12, 2025",
      logo: IPTS_2025,
    },
    {
      id: 2,
      text: "Discover Stall P405 for the Airport GSE Show at Inter Passenger Terminal Expo 2025 | June 11-12, 2025",
      logo: IPTS_2025,
    },
    // {
    //   id: 3,
    //   text: "New Product Launch Coming Soon - Stay Tuned! | Visit us at Hall 4, Bombay Exhibition Center, NESCO, Mumbai, India",
    //   logo: IPTS_2025_Inv,
    // }
  ];
 
  useEffect(() => {
    const ticker = tickerRef.current;
    let animation;
 
    const startAnimation = () => {
      if (!ticker) return;
      const tickerWidth = ticker.scrollWidth;
      const containerWidth = ticker.parentElement.offsetWidth;
 
      ticker.style.transform = `translateX(${containerWidth}px)`;
 
      animation = ticker.animate([
        { transform: `translateX(${containerWidth}px)` },
        { transform: `translateX(-${tickerWidth}px)` }
      ], {
        duration: tickerWidth * 15, // Slower scrolling
        iterations: Infinity,
        easing: 'linear'
      });
    };
 
    setTimeout(startAnimation, 500);
 
    return () => {
      if (animation) animation.cancel();
    };
  }, []);
 
  // return (
  //   <div className="fixed bottom-0 left-0 w-full bg-blue-600 text-white z-[1000] shadow-2xl border-t-2 border-yellow-300 overflow-hidden">
  //     <div className="overflow-hidden w-full">
  //       <div ref={tickerRef} className="flex flex-nowrap whitespace-nowrap py-4 px-2">
  //         {[...newsItems, ...newsItems].map((item, index) => (
  //           <div key={`${item.id}-${index}`} className="flex items-center mx-6 bg-opacity-20 bg-white rounded-lg px-4 py-2 hover:bg-opacity-30 transition-all duration-300 min-w-fit">
  //             <img src={item.logo} alt="Logo" className="h-8 w-8 mr-2 object-contain animate-pulse" />
  //             <span className="text-sm font-semibold tracking-wide">{item.text}</span>
  //             <span className="mx-4 text-yellow-300 text-lg font-bold">★</span>
  //           </div>
  //         ))}
  //       </div>
  //     </div>
  //   </div>
  // );
};
 
export default NewsTicker;